// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_TemplateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for template endpoint
 *
 * Returns a plano record with nested itens array.
 *
 * @see Planoscontas_TemplateItemRow
 */
import type { Planoscontas_TemplateItemRow } from './Planoscontas_TemplateItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_TemplateResponseDados {
id: number
franquia_id: number
status: string
created_at: string
updated_at: string
itens: Planoscontas_TemplateItemRow[]
nome?: string
}

export type Planoscontas_TemplateResponse = ApiResponse<Planoscontas_TemplateResponseDados>;

registerResponseContract('Planoscontas_TemplateResponse', {
  id:          { type: 'number',  required: true },
  franquia_id: { type: 'number',  required: true },
  status:      { type: 'string',  required: true },
  created_at:  { type: 'string',  required: true },
  updated_at:  { type: 'string',  required: true },
  itens: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: false },
      plano_id:          { type: 'number',  required: false },
      categoria_id:      { type: 'number',  required: false },
      tipo:              { type: 'string',  required: false },
      percentual_custom: { type: 'string',  required: false },
      valor_previsto:    { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      categoria_nome:    { type: 'string',  required: false },
    },
  },
  nome:        { type: 'string',  required: false },
})
